import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
// import PersistStore from 'spa-ionata-admin/lib/services/PersistStore';
// import { isDev } from '@/config';
// import SiteLayout from '@/models/SiteLayout';

// const _store = new PersistStore('ext-nav', {
//   storage: sessionStorage,
//   debug: isDev,
// });

type HeaderAndFooter = {
  header: string;
  footer: string;
};

@Module({
  name: 'ExtNavModule',
  namespaced: true,
})
export default class ExtNavModule extends VuexModule {
  fetchResult = new ObservedPromise<HeaderAndFooter>();

  get isLoading() {
    return this.fetchResult.isPending;
  }

  get error() {
    return this.fetchResult.error;
  }

  get header() {
    return this.fetchResult.value?.header || null;
  }

  get footer() {
    return this.fetchResult.value?.footer || null;
  }

  @Mutation
  fetchHtml() {
    const promise = (async (): Promise<HeaderAndFooter> => {
      // const persisted = _store.load();
      // if (
      //   typeof persisted === 'object' &&
      //   'header' in persisted &&
      //   'footer' in persisted
      // ) {
      //   const { header, footer } = persisted;
      //   if (
      //     typeof header === 'string' &&
      //     header.length > 0 &&
      //     typeof footer === 'string' &&
      //     footer.length > 0
      //   ) {
      //     return { header, footer };
      //   }
      // }
      let { header, footer } = await fetchExtNav();
      header = header.replace(/[ \t]+/g, ' ').replace(/[\r\n]+/g, '\n');
      footer = footer.replace(/[ \t]+/g, ' ').replace(/[\r\n]+/g, '\n');
      const data = { header, footer };
      // if (header.length < 5000 && footer.length < 5000) {
      //   _store.persist(data);
      // } else {
      //   _store.clear();
      // }
      return data;
    })();
    this.fetchResult = new ObservedPromise(promise);
  }

  @Action
  async fetchIfNeeded() {
    const { isPending, value } = this.fetchResult;
    if (value != null) {
      return;
    }
    try {
      if (!isPending) {
        this.context.commit('fetchHtml');
      }
      await this.fetchResult.promise;
    } catch {
      // Check this.error
    }
  }
}

const _header = `
<svg xmlns="http://www.w3.org/2000/svg" style="position:absolute; width: 0; height: 0"><defs><clipPath id="cross-a"> <path fill="none" d="M0 0h15v15.05H0z"></path></clipPath><clipPath id="picture-a"> <path fill="none" d="M0 0h21.68v20.05H0z"></path></clipPath><clipPath id="search-a"> <path fill="none" d="M0 0h17.43v17.42H0z"></path></clipPath></defs><symbol viewBox="0 0 15 15.05" id="icon-cross"><g clip-path="url(#cross-a)"><path d="M7.5 6.36L13.62.24a.65.65 0 0 1 .65-.24c.42.06.44.17.55.3a.78.78 0 0 1-.07 1.07L8.63 7.5l6.13 6.12c.56.61-.29 1.92-1.14 1.14L7.5 8.63l-6.13 6.13c-.45.42-.57.29-.84.19a.84.84 0 0 1-.3-1.33L6.36 7.5.24 1.38A.64.64 0 0 1 0 1.05.8.8 0 0 1 .79 0h.06a.69.69 0 0 1 .52.24z" fill="currentColor"></path></g></symbol><symbol viewBox="0 0 1792 1408" id="icon-email"><path fill="currentColor" d="M1792 454v794c0 44-15.7 81.7-47 113s-69 47-113 47H160c-44 0-81.7-15.7-113-47s-47-69-47-113V454c29.3 32.7 63 61.7 101 87 241.3 164 407 279 497 345 38 28 68.8 49.8 92.5 65.5s55.2 31.7 94.5 48 76 24.5 110 24.5h2c34 0 70.7-8.2 110-24.5s70.8-32.3 94.5-48S1156 914 1194 886c113.3-82 279.3-197 498-345 38-26 71.3-55 100-87zm0-294c0 52.7-16.3 103-49 151s-73.3 89-122 123c-250.7 174-406.7 282.3-468 325-6.7 4.7-20.8 14.8-42.5 30.5s-39.7 28.3-54 38-31.7 20.5-52 32.5-39.5 21-57.5 27-34.7 9-50 9h-2c-15.3 0-32-3-50-9s-37.2-15-57.5-27-37.7-22.8-52-32.5-32.3-22.3-54-38-35.8-25.8-42.5-30.5c-60.7-42.7-148-103.5-262-182.5S194.7 450 172 434c-41.3-28-80.3-66.5-117-115.5S0 224 0 182c0-52 13.8-95.3 41.5-130S108.7 0 160 0h1472c43.3 0 80.8 15.7 112.5 47s47.5 69 47.5 113z"></path></symbol><symbol viewBox="-1766.1 2514.4 16 16" id="icon-facebook"><path d="M-1753.9 2514.5c-.2 0-1.2-.1-2.2-.1-2.1 0-3.7 1.4-3.7 3.8v2.1h-2.4v2.8h2.4v7.3h2.9v-7.3h2.4l.4-2.8h-2.8v-1.8c0-.8.2-1.4 1.4-1.4h1.5v-2.6h.1z" fill="currentColor"></path></symbol><symbol viewBox="0 0 40 40" id="icon-info"><path fill="#FFF" d="M40 40H0V0h40v40zM1 39h38V1H1v38z"></path><path fill="#FFF" d="M19.45 18.08c-.36 0-.74.06-1.14.19s-.83.28-1.27.46l-.18.74c.13-.05.29-.1.47-.16s.36-.08.53-.08c.35 0 .59.06.72.18.12.12.19.33.19.64 0 .17-.02.35-.06.56-.04.2-.09.42-.15.65l-.67 2.39c-.06.25-.1.47-.13.67-.03.2-.04.39-.04.58 0 .49.18.89.54 1.21.36.32.87.48 1.52.48.42 0 .8-.06 1.12-.17.32-.11.75-.27 1.29-.49l.18-.74c-.09.04-.24.09-.45.15-.21.06-.39.09-.56.09-.35 0-.59-.06-.74-.17-.14-.11-.21-.33-.21-.65 0-.12.02-.31.07-.56.04-.25.09-.46.15-.65l.67-2.38c.07-.22.11-.46.14-.72.02-.26.04-.44.04-.55 0-.5-.17-.91-.53-1.22-.35-.29-.85-.45-1.5-.45m2.63-1.79c.31-.29.47-.64.47-1.06 0-.41-.16-.77-.47-1.06-.31-.29-.69-.44-1.13-.44s-.82.15-1.13.44c-.32.29-.47.65-.47 1.06 0 .41.16.77.47 1.06.32.29.69.44 1.13.44s.82-.15 1.13-.44M29.41 20c0 5.19-4.22 9.41-9.41 9.41s-9.41-4.22-9.41-9.41 4.22-9.41 9.41-9.41 9.41 4.22 9.41 9.41m2.09 0c0-6.34-5.16-11.5-11.5-11.5S8.5 13.66 8.5 20 13.66 31.5 20 31.5 31.5 26.34 31.5 20"></path></symbol><symbol viewBox="0 0 1536 1536" id="icon-instagram"><path fill="currentColor" d="M1024 768q0-106-75-181t-181-75q-106 0-181 75t-75 181q0 106 75 181t181 75q106 0 181-75t75-181zm138 0q0 164-115 279t-279 115q-164 0-279-115T374 768q0-164 115-279t279-115q164 0 279 115t115 279zm108-410q0 38-27 65t-65 27q-38 0-65-27t-27-65q0-38 27-65t65-27q38 0 65 27t27 65zM768 138q-7 0-76.5-.5t-105.5 0q-36 .5-96.5 3t-103 10Q344 158 315 169a261.82 261.82 0 0 0-146 146q-11 29-18.5 71.5t-10 103q-2.5 60.5-3 96.5t0 105.5q.5 69.5.5 76.5t-.5 76.5q-.5 69.5 0 105.5t3 96.5q2.5 60.49 10 103T169 1221a261.82 261.82 0 0 0 146 146q29 11 71.5 18.5t103 10q60.5 2.51 96.5 3t105.5 0q69.5-.49 76.5-.5t76.5.5q69.5.49 105.5 0t96.5-3q60.49-2.51 103-10t71.5-18.5a261.82 261.82 0 0 0 146-146q11-29 18.5-71.5t10-103q2.51-60.5 3-96.5t0-105.5q-.5-69.5-.5-76.5t.5-76.5q.49-69.5 0-105.5t-3-96.5q-2.51-60.49-10-103T1367 315a261.82 261.82 0 0 0-146-146q-29-11-71.5-18.5t-103-10q-60.5-2.5-96.5-3t-105.5 0q-69.5.5-76.5.5zm768 630q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124T5 1085q-5-88-5-317t5-317q10-208 124-322T451 5q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"></path></symbol><symbol viewBox="0 0 1792 1792" id="icon-linkedin"><path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z" fill="#fff"></path></symbol><symbol viewBox="0 0 21.68 20.05" id="icon-picture"><g clip-path="url(#picture-a)"><path d="M7 10.06l5.14 5.14a.81.81 0 0 0 1.15 0l3.22-3.46 3.5 3.5v2.93a.25.25 0 0 1-.27.27H1.9a.25.25 0 0 1-.27-.27V15zm5.3-5.72h.15a1.29 1.29 0 1 1-.15 0m.15-1.63a3 3 0 1 0 3 3 3 3 0 0 0-3-3M1.9 1.63h17.88a.25.25 0 0 1 .27.27v11L17.11 10A.82.82 0 0 0 16 10l-3.22 3.46-5.1-5.1A.79.79 0 0 0 7 8.13a.76.76 0 0 0-.45.21l-4.92 4.45V1.9a.25.25 0 0 1 .27-.27zM1.9 0A1.91 1.91 0 0 0 0 1.9v16.26a1.91 1.91 0 0 0 1.9 1.89h17.88a1.91 1.91 0 0 0 1.9-1.89V1.9a1.91 1.91 0 0 0-1.9-1.9z" fill="#fff"></path></g></symbol><symbol viewBox="0 0 22.71 22.71" id="icon-pinterest"><path d="M0 11.36a11.11 11.11 0 0 1 3.42-8.08A11.18 11.18 0 0 1 11.36 0a11.1 11.1 0 0 1 8.14 3.39 11.35 11.35 0 0 1-.2 16 11.14 11.14 0 0 1-7.94 3.3 10.77 10.77 0 0 1-3.2-.49 9.36 9.36 0 0 0 .62-1.11 18.53 18.53 0 0 0 .89-2.84c.09-.38.22-.9.4-1.55a3 3 0 0 0 1.07 1 4.62 4.62 0 0 0 4.21-.18 7 7 0 0 0 3.19-4.13 8.36 8.36 0 0 0-.2-5.39 6.37 6.37 0 0 0-3.57-3.61 9.83 9.83 0 0 0-6.3.2 7 7 0 0 0-4.25 3.84 8.55 8.55 0 0 0-.38 2 9.74 9.74 0 0 0 .06 2 4 4 0 0 0 .67 1.71A3.44 3.44 0 0 0 6 15.26a.36.36 0 0 0 .35 0c.12-.06.24-.3.36-.71a2.11 2.11 0 0 0 .13-.84 3.5 3.5 0 0 0-.18-.31A4.33 4.33 0 0 1 6 10.23a5.6 5.6 0 0 1 1.41-2.82 6.14 6.14 0 0 1 3.83-1.6A5.12 5.12 0 0 1 15 7a4.78 4.78 0 0 1 1.09 2.35 7.32 7.32 0 0 1 0 2.64 8.23 8.23 0 0 1-.87 2.37 3.26 3.26 0 0 1-2.61 1.78 2 2 0 0 1-1.45-.69 1.54 1.54 0 0 1-.34-1.45c.06-.32.24-1 .53-1.9a9.93 9.93 0 0 0 .49-2.13c-.09-1.13-.61-1.7-1.55-1.73a2.11 2.11 0 0 0-1.64 1 4 4 0 0 0-.58 2 5.12 5.12 0 0 0 .4 1.76c-.33 1.33-.58 2.4-.75 3.2-.06.2-.23.84-.49 1.9a13.94 13.94 0 0 0-.45 2.44v1.24a11.59 11.59 0 0 1-5-4.23A11 11 0 0 1 0 11.36" fill="currentColor"></path></symbol><symbol viewBox="0 0 17.79 28.34" id="icon-scroll"><path d="M8.89 28.34A8.9 8.9 0 0 1 0 19.45V8.89a8.9 8.9 0 0 1 17.79 0v10.56a8.9 8.9 0 0 1-8.9 8.89zM8.89 1A7.9 7.9 0 0 0 1 8.89v10.56a7.9 7.9 0 0 0 15.79 0V8.89A7.9 7.9 0 0 0 8.89 1z" fill="currentColor"></path><path d="M8.89 10.84a.51.51 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5.5.5 0 0 1 .5.5v5.05a.5.5 0 0 1-.5.45z" fill="currentColor"></path></symbol><symbol viewBox="0 0 17.43 17.42" id="icon-search"><g clip-path="url(#search-a)"><path d="M13.16 7.3A5.86 5.86 0 1 1 7.3 1.44a5.87 5.87 0 0 1 5.86 5.86m4.06 8.89L13 11.93A7.3 7.3 0 0 0 2.14 2.14 7.34 7.34 0 0 0 0 7.3 7.31 7.31 0 0 0 11.93 13l4.26 4.26a.74.74 0 0 0 1 0 .72.72 0 0 0 0-1" fill="currentColor"></path></g></symbol><symbol viewBox="0 0 18.57 21.7" id="icon-tiktok"><path d="M18.57 8.78h-.53a5.8 5.8 0 0 1-4.85-2.62v8.92a6.6 6.6 0 1 1-6.6-6.59H7v3.25a2.7 2.7 0 0 0-.41 0 3.37 3.37 0 0 0 0 6.74 3.45 3.45 0 0 0 3.5-3.33L10.13 0h3.11a5.78 5.78 0 0 0 5.33 5.17v3.61" fill="currentColor"></path></symbol><symbol viewBox="0 0 21.7 17.6" id="icon-twitter"><style>.st0{fill:currentColor}</style><path class="st0" d="M19.4 4.4c.9-.6 1.6-1.4 2.2-2.3-.8.4-1.7.6-2.5.7.9-.6 1.6-1.4 2-2.4-.9.5-1.8.9-2.8 1.1-.4-.4-.9-.8-1.5-1-2.1-.9-4.5-.1-5.6 1.8-.4.7-.6 1.4-.6 2.2 0 .3 0 .7.1 1-1.8-.1-3.5-.6-5.1-1.4-1.6-.8-3-1.9-4-3.3C1.1 1.4.9 2.2.9 3c0 .7.2 1.5.6 2.1.4.6.8 1.2 1.4 1.6-.7 0-1.4-.2-2-.6v.1c0 1 .3 2 1 2.8.6.8 1.5 1.4 2.5 1.6-.4.1-.8.1-1.2.1h-.8c.3.9.8 1.7 1.6 2.2.7.6 1.7.9 2.6.9C5 15 3.1 15.7 1.1 15.7H0c2 1.3 4.4 2 6.8 2 4.7.1 9.1-2.6 11.2-6.8C19 9 19.5 7 19.5 5c0-.2 0-.4-.1-.6"></path></symbol><symbol viewBox="0 0 1792 1792" id="icon-youtube"><path d="M711 1128l484-250-484-253v503zm185-862q168 0 324.5 4.5T1450 280l73 4q1 0 17 1.5t23 3 23.5 4.5 28.5 8 28 13 31 19.5 29 26.5q6 6 15.5 18.5t29 58.5 26.5 101q8 64 12.5 136.5T1792 788v176q1 145-18 290-7 55-25 99.5t-32 61.5l-14 17q-14 15-29 26.5t-31 19-28 12.5-28.5 8-24 4.5-23 3-16.5 1.5q-251 19-627 19-207-2-359.5-6.5T336 1512l-49-4-36-4q-36-5-54.5-10t-51-21-56.5-41q-6-6-15.5-18.5t-29-58.5T18 1254q-8-64-12.5-136.5T0 1004V828q-1-145 18-290 7-55 25-99.5T75 377l14-17q14-15 29-26.5t31-19.5 28-13 28.5-8 23.5-4.5 23-3 17-1.5q251-18 627-18z" fill="currentColor"></path></symbol></svg>
<header class="l-site-header" role="banner">
    <h1 class="visuallyhidden">Brand Tas</h1>
    <a href="https://trade.tasmanian.com.au/home" class="l-site-header__logo">
        <span class="visuallyhidden">Home</span>
        <img aria-hidden="true" src="https://trade.tasmanian.com.au/__data/assets/file/0015/291210/logo.svg" alt="">
    </a>

<nav class="l-navigation" role="navigation" data-navigation-target="">
    
<div class="l-navigation__item" data-mobile-submenu="">
<a href="https://trade.tasmanian.com.au/directory" class="l-navigation__item-link" data-mobile-submenu-opener="">Directory</a>
</div>    
    
<div class="l-navigation__item" data-mobile-submenu="">
<a href="https://trade.tasmanian.com.au/experience_tasmania" class="l-navigation__item-link" data-mobile-submenu-opener="">Experience Tasmanian</a>
</div>



<div class="l-navigation__item" data-mobile-submenu="">
    <a href="https://trade.tasmanian.com.au/trade_opportunities" class="l-navigation__item-link" data-mobile-submenu-opener="">Trade Opportunities</a>
    <nav class="submenu" data-mobile-submenu-list="">
        <ul class="submenu__links">
            
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/antarctic_and_southern_ocean">Antarctic and Southern Ocean</a>
                </li>
            
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/defence">Defence</a>
                </li>
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/agribusiness">Food, beverage and agribusiness</a>
                </li>
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/forest_products">Forest products</a>
                </li>
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/manufacturing">Manufacturing</a>
                </li>
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/mining_and_mineral_processing">Mining and mineral processing</a>
                </li>
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/maritime">Maritime</a>
                </li>
                <li class="submenu__links-single">
                    <a href="https://trade.tasmanian.com.au/trade_snapshots/technology">Technology</a>
                </li>
        </ul>
    </nav>
</div>
&nbsp; &nbsp; &nbsp;
<div class="l-navigation__item" data-mobile-submenu="">
<a href="https://trade.tasmanian.com.au/contact_us" class="l-navigation__item-link" data-mobile-submenu-opener="">Contact</a>
</div>

</nav>
    

    <!--<button class="l-site-header__icon-link" data-search-opener="">
        <div class="icon-cycle">
           
			<svg viewBox="0 0 31 31">
				<use xlink:href="#icon-instagram"></use>
			</svg>
			<svg viewBox="0 0 31 31">
			    <use xlink:href="#icon-facebook"></use>
			</svg>
			<svg viewBox="0 0 31 31">
				<use xlink:href="#icon-instagram"></use>
			</svg>
			<svg viewBox="0 0 31 31">
				<use xlink:href="#icon-facebook"></use>
			</svg>
           
        </div>
    </button>-->
    <a href="https://trade.tasmanian.com.au/search" class="l-site-header__icon-link l-site-header__icon-link--search" data-search-opener="">
        <svg class="inactive-icon" viewBox="0 0 17.43 17.42">
            <use xlink:href="#icon-search"></use>
        </svg>
        <svg class="active-icon" viewBox="0 0 17.43 17.42">
            <use xlink:href="#icon-cross"></use>
        </svg>
        <span class="visuallyhidden">Open search</span>
    </a>
    <button data-navigation-trigger="" class="l-site-header__icon-link l-site-header__icon-link--menu">
        <div class="inactive-icon menu-icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span class="visuallyhidden">Open menu</span>
        </div>
        <svg class="active-icon" viewBox="0 0 17.43 17.42">
            <use xlink:href="#icon-cross"></use>
        </svg>
    </button>        
</header>
`;

const _footer = `
<footer class="dsg--sub-footer">
           
    <div class="dsg--sub-footer__inner">
        <div class="dsg--sub-footer__logo">
        </div>
        <div class="dsg--sub-footer__links">
            
<div id="content_container_158848_295547">
<ul><li><a href="http://www.tas.gov.au/stds/codi.htm" target="_blank">Copyright and disclaimer</a></li><li><a href="https://www.stategrowth.tas.gov.au/personal_information_protection" title="Personal Information Protection" target="_blank">Personal Information Protection</a></li><li><a href="https://www.stategrowth.tas.gov.au/accessibility">Accessibility</a></li><li><a href="http://www.service.tas.gov.au" target="_blank">Service Tasmania</a></li><li><a href="https://trade.tasmanian.com.au/image_credits">Image credits</a></li></ul>
</div>
        </div>
    </div>
            
</footer>
`;

const fetchExtNav = async () => {
  // try {
  //   const result = await SiteLayout.fetchLayout();
  //   const { header, footer } = result.data || {};
  //   if (header && footer) {
  //     return { header, footer };
  //   }
  // } catch (err) {
  //   // ignore
  // }
  return { header: _header, footer: _footer };
};
